import React from "react";
import { useIntl } from "react-intl";
import CertificateLink from "../../../OtherAttributesAccordion/components/CertificateLink";
import ExpirationCertificate from "../CertificateRow/components/ExpirationCertificate";
import { calculateCertificateFileExpired } from "../../../OtherAttributesAccordion/constants";
import { LG } from "../../../OtherAttributesAccordion/constants/breakpoints";
import useMediaQuery from "utils/hooks/useMediaQuery";
import { cleanedSustainabilityData, getAttrWithImage, translatedSustainabilityLabel } from "./constants";
import SpecsTableColumn from "../../../SpecsTableRow/components/SpecsTableColumn";
import "./styles/SustainabilityAttrRow.scss";
import { SUSTAINABILITY_ATTRIBUTES } from "../../constants/attributesByGroups";
import CarboonFootprintDisclaimer from "./components/CarboonFootprintDisclaimer";

const SustainabilityAttrRow = ({ currentAttr, currentGroup, certificateDomain }) => {
  const showCarboonFootprintDisclaimer = SUSTAINABILITY_ATTRIBUTES["attributes"].carbonFootprintRange.includes(currentAttr.title)

  const intl = useIntl();
  const isMobile = useMediaQuery(LG);
  const areNotCertificates = !currentGroup.areCertificates;
  
  let cleanedData = cleanedSustainabilityData(currentAttr, areNotCertificates); // Convert the currentAttr object in an array
  const [isAttrWithImgToShow, isStaticImg] = getAttrWithImage(cleanedData);
  
  if (isAttrWithImgToShow) {
    const imgTag = <img src={!isStaticImg ? `${certificateDomain}${cleanedData[3]}` : cleanedData[3]} alt={cleanedData[0]} className={`${cleanedData[0]}-image`} width={80} />;

    cleanedData[0] = 
      isStaticImg 
        ? imgTag
        : cleanedData[0]

    cleanedData[1] = 
      isStaticImg 
        ? ""
        : imgTag

    cleanedData[3] = ""
  }

  // Validation for certificates expires data
  if (cleanedData && cleanedData[2] !== "") {
    // If have certificate but not have expires data or not expires data then the certificate is not valid
    if (!cleanedData[3]) {
      cleanedData[2] = ""
    } else {
      // If have certificate file expires date the length of the cleaned array is 5
      const expiresValue = cleanedData.length > 4 ? cleanedData[3] : cleanedData[2]
      const notExpiresValue = cleanedData.length > 4 ? cleanedData[4] : cleanedData[3]
      
      if (expiresValue || notExpiresValue) {
        cleanedData[3] = cleanedData[2]
  
        const resultExpiresValue = calculateCertificateFileExpired(expiresValue, notExpiresValue);
        cleanedData[2] = <ExpirationCertificate expiredData={resultExpiresValue} onlyCircleWithoutText={isMobile} isSustainabilityData /> ?? null
  
        // Clean the data for the certificate
        cleanedData[4] = null;
      }
    }
  }

  // Translate the sustainability label
  if (cleanedData) {
    cleanedData[0] = 
      typeof cleanedData[0] === "string" 
        ? translatedSustainabilityLabel(cleanedData[0], intl) 
        : cleanedData[0];
  }

  cleanedData = cleanedData && cleanedData.filter((value) => value !== null);
  return (
    <>
      <tr>
        {cleanedData?.map((value, index) => {
          return <td key={`item-${value}-${index}`} width={"25%"}>
            {index === 3 && value ? (
              <SpecsTableColumn value={<CertificateLink link={`${certificateDomain}${value}`} />} />
            ) : (
              <SpecsTableColumn value={value} />
            )}
          </td>
        }) ?? null}
      </tr>
      {showCarboonFootprintDisclaimer && <CarboonFootprintDisclaimer />}
    </>
  );
}

export default SustainabilityAttrRow